import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';


@Component({
	selector: 'message',
	templateUrl: './message.component.html',
	imports: [
		NgbToastModule
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class MessageComponent {

	@Input() text = '';

}
